import pageSelector from 'common/selectors/pageSelector';
import { uiLoadingComplete } from 'lib/ui/loading';
import observeStore from './observeStore';

export default function scoringObserver(store) {
    return observeStore(store, pageSelector, (currentPage, nextPage) => {
        if (nextPage.scored === true) {
            uiLoadingComplete();
        }
    });
};



// WEBPACK FOOTER //
// ./app/lib/observe/scoringObserver.js